import React, { Component } from "react"

import CodeEditor from "../components/CodeEditor";

import "../tabs-left.css";

import {
    Tab,
    Row,
    Col,
    Nav,
    NavItem,
    Modal,
    Button,
    Grid
} from "react-bootstrap";

export default class fileNavigator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };
  }

  showDemo = () => {
    this.setState({show: true});
  }

  close = () => {
    this.setState({show: false});
  }

  render() {
    let files = this.props.files.filter(file => {
      if (this.props.hiddenFiles != null && this.props.hiddenFiles.some(filename => file.filename === filename)) {
        return false;
      }
      return file.filename.endsWith(".js");
    })

    const tabSection = files.map((file, index) => {
      return <NavItem key={index} eventKey={"file"+index}>{file.filename}</NavItem>;
    });

    return (
      <span>
        <Row className="with-margin">
          <Tab.Container id="fileNavigator" defaultActiveKey="file0">
            <Grid flexible={true}>
            <Row className="clearfix">
              <Col sm={2} className="nopadding">
                <Nav className="tabs-left" bsStyle="tabs" stacked>
                  {tabSection}
                </Nav>
              </Col>
              <Col sm={4} className="nopadding">
                <Tab.Content animation>
                  {files.map((file, index) => {
                    return (
                      <Tab.Pane eventKey={"file"+index}>
                        <CodeEditor id={index} readOnly value={file.content} />
                      </Tab.Pane>
                    );
                  })}
                </Tab.Content>
              </Col>
            </Row>
            </Grid>
          </Tab.Container>
        </Row>
        <Row>
          <Button
            className="pull-right"
            bsStyle="primary"
            bsSize="small"
            onClick={() => this.showDemo()}>
            View Demo
          </Button>
        </Row>
        <Modal
          show={this.state.show}
          onHide={this.close}
          container={this}
          aria-labelledby="modal-title" >
          <Modal.Header closeButton>
            <Modal.Title id="modal-title">Demo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.props.demoPath &&
              <iframe frameBorder="0" height="400px" width="550px" src={this.props.demoPath}/>
            }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>Close</Button>
          </Modal.Footer>
        </Modal>
      </span>
      
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/FileNavigator.js